export const production = process.env.REACT_APP_production === 'true';
export const serverUrl = process.env.REACT_APP_serverUrl;
export const fileUrl = process.env.REACT_APP_FILE_URL;
export const googleApiKey = process.env.REACT_APP_GOOGLEAPI_KEY;
